export function validateCollectionSearch(search: Record<string, unknown>): { collection?: string } {
  return typeof search.collection === 'string' && search.collection.length <= 64
    ? { collection: search.collection }
    : {};
}
